import React, {Component} from 'react';
import Header from "../../../layouts/Header";
import EmptyPic from "../../../assets/images/emptypic.png"
import {showError, showSuccess, showWarning} from "../../../utils/toastHelper";
import {getUserInfo, updateProfile} from "../api/ProfileAPIs";


class EditProfile extends Component {
    state = {
        avatar: null,
        last_name: '',
        first_name: '',
        username: '',
        national_code: '',
        otp_password: '',

        phone: '',
        description: '',

        email: '',
        file: null,
        pic: EmptyPic,

        buttonStatus: "",
        buttonText: "ثبت تغییرات",
        loading: "d-none",
    }
    onFileChange = (event) => {
        let reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
            this.setState({
                pic: reader.result,
                file: event.target.files[0]
            })
        };

    }
    onInputChange = (event) => {
        const inputName = event.target.name;
        const inputValue = event.target.value;
        this.setState({[inputName]: inputValue});

    }

    onButtonClick = async () => {
        if (this.state.last_name.length < 3) {
            showWarning('لطفا نام خانوادگی را درست وارد کنید');
            return false
        }
        if (this.state.otp_password.length > 0 && this.state.otp_password.length !== 4) {
            showWarning('پسورد ثابت بایستی حتما ۴ رقم باشد');
            return false
        }
        const buttonText = "";
        const loading = "d-inline-block";
        const buttonStatus = "disabled";
        this.setState({buttonText, loading, buttonStatus});
        const formData = new FormData();
        const file = this.state.file;
        if (file)
            formData.append('avatar', file);
        formData.append('last_name', this.state.last_name);
        formData.append('first_name', this.state.first_name ? this.state.first_name : '');
        formData.append('national_code', this.state.national_code ? this.state.national_code : '');
        formData.append('phone', this.state.phone);
        formData.append('otp_password', this.state.otp_password);
        formData.append('old_pass', this.state.old_pass);
        if (this.state.email)
            formData.append('email', this.state.email);
        /*        formData.append('province_id', this.state.province_id);
                formData.append('city_id', this.state.city_id);*/
        formData.append('device_info', navigator.userAgent);

        try {
            const response = await updateProfile(formData);
            showSuccess(response.message);
            const buttonText = "ثبت تغییرات";
            const loading = "d-none";
            const buttonStatus = "";
            this.setState({buttonText, loading, buttonStatus});
        } catch (err) {
            showError(err);
            const buttonText = "ثبت تغییرات";
            const loading = "d-none";
            const buttonStatus = "";
            this.setState({buttonText, loading, buttonStatus});
        } finally {

        }

    }


    render() {
        return (
            <React.Fragment>

                <Header hasBack={true} title='ویرایش پروفایل'/>
                <section className="container rtl  p-3  mt-4 pt-5 ">
                    <div className="row">
                        <div className="col-12 text-center">
                            {/*   <span onClick={this.onExitClick} className='p-2 badge badge-info badge-pill bg-danger'>
        خروج از اپلیکیشن
    </span>*/}
                        </div>
                        <div className="col-12 mb-4">

                            <img alt="Avatar"
                                 src={(this.state.avatar && !this.state.file) ? this.state.avatar : this.state.pic}
                                 width={64} className='rounded-circle'/>
                            <span className="px-5">
                                                <label className="custom-file-upload float-left mt-3">
                                                    انتخاب تصویر پروفایل جدید
                                                 <input type="file" onChange={this.onFileChange}/>
                                                </label>
                                            </span>
                        </div>

                        {
                            this.state.company_name?.length > 0 ?
                                <div className="form-floating col-md-6 mt-2">
                                    <input type="text"
                                           className="form-control px-5"
                                           id="company_name" name="company_name"
                                           placeholder="نام"
                                           value={this.state.company_name}
                                           onChange={this.onInputChange}/>
                                    <label htmlFor="company_name" className="right-0">نام شرکت</label>
                                </div>
                                :
                                <div className="form-floating col-md-6 mt-2">
                                    <input type="text"
                                           className="form-control px-5"
                                           id="first_name" name="first_name"
                                           placeholder="نام"
                                           value={this.state.first_name}
                                           onChange={this.onInputChange}/>
                                    <label htmlFor="first_name" className="right-0">نام</label>
                                </div>
                        }


                        <div className="form-floating col-md-6 mt-2">
                            <input type="text"
                                   className="form-control px-5"
                                   id="last_name" name="last_name"
                                   placeholder="نام خانوادگی"
                                   value={this.state.last_name}
                                   onChange={this.onInputChange}/>
                            <label htmlFor="last_name" className="right-0">نام خانوادگی
                                {
                                    this.state.company_name?.length > 0  && ' نماینده شرکت'
                                }
                            </label>
                        </div>
                        <div className="form-floating col-md-6 mt-2">
                            <input type="text"
                                   className="form-control px-5 text-left"
                                   id="username" name="username"
                                   placeholder="شماره موبایل"
                                   value={this.state.username.replace('+98', '0')}
                                   disabled
                            />
                            <label htmlFor="mobile" className="right-0">شماره موبایل</label>
                        </div>
                        <div className="form-floating col-md-6 mt-2">
                            <input type="number"
                                   className="form-control px-5"
                                   id="national_code" name="national_code"
                                   placeholder="کد ملی"
                                   value={this.state.national_code ? this.state.national_code : ''}
                                   onChange={this.onInputChange}
                            />
                            <label htmlFor="national_code" className="right-0">
                                {
                                    this.state.company_name?.length > 0 ? 'شناسه ملی شرکت' : 'کد ملی'
                                }
                            </label>
                        </div>
                    </div>
                </section>
                <section className="container rtl  px-3 usual-content  ">
                    <div className="row">
                        <div className="form-floating col-md-6 mt-2">
                            <input type="email"
                                   className="form-control px-5"
                                   id="email" name="email"
                                   placeholder="آدرس ایمیل"
                                   value={this.state.email ? this.state.email : ''}
                                   onChange={this.onInputChange}
                            />
                            <label htmlFor="email" className="right-0">آدرس ایمیل</label>
                        </div>
                        <div className="form-floating col-md-6 mt-2">
                            <input type="number"
                                   className="form-control px-5"
                                   id="phone" name="phone"
                                   placeholder="شماره تماس ثابت"
                                   value={this.state.phone ? this.state.phone : ''}
                                   onChange={this.onInputChange}
                            />
                            <label htmlFor="phone" className="right-0">شماره تماس ثابت</label>
                        </div>

                    </div>

                    <div className="row bg-secondary-subtle p-2 mt-3 rounded mx-2">
                        <div className="form-floating col-md-6 mt-2">
                            <input type="number"
                                   className="form-control px-5"
                                   id="old_pass" name="old_pass"
                                   placeholder="پسورد قبلی"
                                   value={this.state.old_pass ? this.state.old_pass : ''}
                                   onChange={this.onInputChange}
                            />
                            <label htmlFor="old_pass" className="right-0"> رمز عبور کنونی </label>
                            <p className='text-small-2 text-muted'>
                                در صورتی که تا کنون کلمه عبوری برای خود تعیین نکرده اید این گزینه را خالی بگذارید
                            </p>
                        </div>
                        <div className="form-floating col-md-6 mt-2">
                            <input type="number"
                                   className="form-control px-5"
                                   id="otp_password" name="otp_password"
                                   placeholder="پسورد جدید"
                                   value={this.state.otp_password ? this.state.otp_password : ''}
                                   onChange={this.onInputChange}
                            />
                            <label htmlFor="otp_password" className="right-0">رمز عبور جدید
                                </label>
                            <p className='text-small-2 text-muted'>
                                یک رمز عبور ۴ رقمی برای خود تعیین کنید تا در هنگام ورود دوباره به اپلیکیشن با این رمز
                                عبور وارد شوید.
                            </p>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-12 p-2 mobile-size-option">
                            <button
                                className="btn btn-primary text-center bg-primary-color text-semi-big w-100 p-2 pr-4"
                                onClick={this.onButtonClick}
                                disabled={this.state.buttonStatus}
                            >


                                &nbsp;
                                {this.state.buttonText}
                                <span className={"spinner-grow spinner-grow-sm " + this.state.loading} role="status"
                                      aria-hidden="true">

                                </span>

                            </button>
                        </div>
                    </div>
                </section>

            </React.Fragment>
        );
    }

    componentDidMount = async () => {
        try {
            const data = await getUserInfo();
            this.setState(data.data.user)

        } catch (err) {
            showError(err);
        } finally {

        }

    }
}

export default EditProfile;